var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupprimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "supprimer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.61,124.88h-266c-3.83,0-6.91,3.13-6.79,6.89l10.32,318.91c0.12,3.6,3.13,6.45,6.79,6.45H373.3 c3.67,0,6.67-2.85,6.79-6.45l10.32-318.91C390.52,128,387.44,124.88,383.61,124.88z M211.89,384.71c0,8.44-6.99,15.31-15.59,15.31 c-8.61,0-15.59-6.87-15.59-15.31V190.6c0-8.44,6.97-15.31,15.59-15.31c4.29,0,8.19,1.71,11.02,4.49c2.82,2.77,4.57,6.59,4.57,10.82 V384.71z M319.47,384.71c0,8.44-6.97,15.31-15.59,15.31c-8.59,0-15.59-6.87-15.59-15.31V190.6c0-8.44,6.99-15.31,15.59-15.31 c4.31,0,8.21,1.71,11.02,4.49c2.82,2.77,4.57,6.59,4.57,10.82V384.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M407.56,107.54H92.62c-1.87,0-3.39-1.52-3.39-3.39v-50.8c0-1.87,1.52-3.39,3.39-3.39h314.94 c1.87,0,3.39,1.52,3.39,3.39v50.8C410.95,106.03,409.43,107.54,407.56,107.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.22,77.12H208c-1.87,0-3.39-1.52-3.39-3.39v-50.8c0-1.87,1.52-3.39,3.39-3.39h85.23 c1.87,0,3.39,1.52,3.39,3.39v50.8C296.61,75.61,295.1,77.12,293.22,77.12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupprimer);
export default __webpack_public_path__ + "static/media/supprimer.0287af29c9aa17be862dc83717319a95.svg";
export { ForwardRef as ReactComponent };